import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';
import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.kiera.cluster.deploy');
import { OnInit } from '@angular/core';
import { Service } from 'src/libs/portal/season/service';

@Component({
 standalone: false,
 selector: 'wiz-page-kiera-cluster-deploy',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/.kiera-build/src/app/page.kiera.cluster.deploy/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageKieraClusterDeployComponent implements OnInit {
    public list: any[] = [];
    public total: number = 0;
    public search: any = { text: '', page: 1, dump: 20 };
    public pageSizeOptions: number[] = [10, 20, 50];
    public loading: boolean = false;
    public errorMessage: string = '';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.load(1);
    }

    public async load(page: number = this.search.page) {
        this.search.page = Math.max(1, Number(page || 1));
        this.loading = true;
        this.errorMessage = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('search', this.search);
            if (code === 200) {
                this.list = data?.rows || [];
                this.total = Number(data?.total || 0);
            } else {
                this.errorMessage = data?.message || 'Failed to load clusters.';
            }
        } catch (error) {
            this.errorMessage = String(error || 'Failed to load clusters.');
        }
        this.loading = false;
        await this.service.render();
    }

    public async refresh() {
        await this.load(this.search.page);
    }

    public async changePageSize() {
        this.search.page = 1;
        await this.load(1);
    }

    public totalPages(): number {
        return Math.max(1, Math.ceil(this.total / Number(this.search.dump || 20)));
    }

    public pageList(): number[] {
        const total = this.totalPages();
        const current = Number(this.search.page || 1);
        const pages: number[] = [];
        const start = Math.max(1, current - 2);
        const end = Math.min(total, current + 2);
        for (let page = start; page <= end; page++) pages.push(page);
        return pages;
    }

    public openCluster(item: any) {
        const path = item?.detail_path || `/kiera/cluster-deploy/${item?.id || ''}/overview`;
        if (!item?.id) return;
        this.service.href(path);
    }

    public datePart(value: any): string {
        const text = String(value || '').trim();
        if (!text) return '-';
        return text.split(/[T ]/)[0] || text;
    }

    public timePart(value: any): string {
        const text = String(value || '').trim();
        if (!text) return '';
        const time = text.includes('T') ? text.split('T')[1] : text.split(' ')[1];
        return String(time || '').replace(/\.\d+$/, '').replace(/Z$/, '');
    }

    public clusterTypeBadgeClass(item: any): string {
        const value = String(item?.cluster_type || '').toLowerCase();
        return value === 'template'
            ? 'bg-violet-100 text-violet-700 ring-1 ring-violet-200'
            : 'bg-blue-100 text-blue-700 ring-1 ring-blue-200';
    }

    public deploymentTypeBadgeClass(item: any): string {
        const value = String(item?.deployment_type || '').toLowerCase();
        return value === 'relay'
            ? 'bg-emerald-100 text-emerald-700 ring-1 ring-emerald-200'
            : 'bg-orange-100 text-orange-700 ring-1 ring-orange-200';
    }

    public deploymentTypeCaption(item: any): string {
        return String(item?.deployment_type || '').toLowerCase() === 'relay' ? '(중계서버 기반)' : '(직접 배포)';
    }

    public statusBadgeClass(item: any): string {
        const key = String(item?.deployment_state?.key || '').toLowerCase();
        if (key === 'deployed') return 'bg-emerald-100 text-emerald-700';
        if (key === 'deploying') return 'bg-orange-100 text-orange-700';
        if (key === 'failed') return 'bg-rose-100 text-rose-700';
        if (key === 'configured') return 'bg-blue-100 text-blue-700';
        return 'bg-zinc-100 text-zinc-600';
    }

    public statusDotClass(item: any): string {
        return item?.deployment_state?.dot || 'bg-zinc-500';
    }

    public lastDeployText(item: any): string {
        const value = String(item?.last_deploy || '').trim();
        if (!value) return '-';
        const date = this.datePart(value);
        const time = this.timePart(value);
        return time ? `${date} ${time}` : date;
    }
}

export default PageKieraClusterDeployComponent;
